<template>
<v-app-bar app dark color="primary">
    <router-link :to="{ name: 'Dashboard'}" class="white--text" style="text-decoration: none;margin-right:20px"><v-toolbar-title>POKO</v-toolbar-title></router-link>
    <span class="white--text" style="font-size:9pt">{{ title }}</span>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <!-- Tenant Switcher -->
      <div v-if="canSwitchTenants && availableTenants.length > 0" class="d-flex align-center mr-4">
        <v-select
          v-model="selectedTenantId"
          :items="availableTenants"
          item-text="tenantName"
          item-value="tenantId"
          label="Firma"
          dense
          outlined
          hide-details
          class="tenant-selector"
          dark
          style="max-width: 250px;"
        ></v-select>
        <v-btn
          color="success"
          small
          class="ml-2"
          @click="switchTenant"
          :disabled="!isTenantChanged || isSwitching"
          :loading="isSwitching"
        >
          Zmień
        </v-btn>
      </div>

      <v-menu bottom right offset-y  v-if="currentUser">
        <template v-slot:activator="{on}">
          <v-btn text  v-on="on">{{currentUser}}<v-icon>fa-caret-down</v-icon></v-btn>
        </template>
        <v-list>
          <v-list-item key="1" router :to="{name: 'ChangePassword'}">
            <v-list-item-action>
              <v-list-item-title>Zmień hasło</v-list-item-title>
            </v-list-item-action>
          </v-list-item>
          <v-list-item key="2" router :to="{name: 'Settings2FA'}">
            <v-list-item-action>
              <v-list-item-title>Ustawienia - uwierzytelniania dwuskładnikowego</v-list-item-title>
            </v-list-item-action>
          </v-list-item>
          <v-list-item key="3" router :to="{name: 'Login'}">
            <v-list-item-action>
              <v-list-item-title>{{ logInText }}</v-list-item-title>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
</v-app-bar>

</template>

<script>
import { store } from '@/store'
import { tenantService } from '@/services'

export default {
    name: 'Navbar',
    data() {
        return {
            availableTenants: [],
            selectedTenantId: null,
            currentTenantId: null,
            isSwitching: false
        }
    },
    computed:
    {
        logInText() {
            return store.state.account.user == null ? "Zaloguj" : "Wyloguj"
        },
        title() {
            return store.state.title.title
        },
        currentUser() {
            if(this.$store.state.account.userdetails != null)
            {
                return this.$store.state.account.userdetails.name
            }
            return null;
        },
        canSwitchTenants() {
            // Check if user has POKO_TenantSwitching permission
            return this.$can('do', 'POKO_TenantSwitching')
        },
        isTenantChanged() {
            return this.selectedTenantId !== null &&
                   this.currentTenantId !== null &&
                   this.selectedTenantId !== this.currentTenantId
        },
        permissionsLoaded() {
            return this.$store.getters['account/status_permissions']
        },
        tenantDetails() {
            return this.$store.getters['account/tenant_details']
        }
    },
    watch: {
        permissionsLoaded(newValue) {
            // When permissions are loaded, check if user can switch tenants
            if (newValue && this.canSwitchTenants && this.currentUser) {
                this.loadAvailableTenants()
            }
        }
    },
    methods: {
        async loadAvailableTenants() {
            try {
                // Get current tenant ID from login information
                if (this.tenantDetails && this.tenantDetails.id) {
                    this.currentTenantId = this.tenantDetails.id
                    this.selectedTenantId = this.tenantDetails.id
                }

                const response = await tenantService.getMyAvailableTenants()
                if (response.data && response.data.result) {
                    this.availableTenants = response.data.result
                }
            } catch (error) {
                console.error('Error loading available tenants:', error)
            }
        },
        async switchTenant() {
            if (!this.isTenantChanged) {
                return
            }

            this.isSwitching = true
            try {
                await tenantService.switchToTenant(this.selectedTenantId)
                // Reload the page to apply the new tenant context
                window.location.reload()
            } catch (error) {
                console.error('Error switching tenant:', error)
                const errorMessage = (error.response && error.response.data && error.response.data.error && error.response.data.error.message) || 'Nie udało się przełączyć firmy'
                this.$store.dispatch('alert/error', errorMessage)
                // Reset to current tenant on error
                this.selectedTenantId = this.currentTenantId
            } finally {
                this.isSwitching = false
            }
        }
    },
    mounted()
    {
        //elems.dropdown();
        // Load available tenants if permissions are already loaded and user has permission                
        if (this.permissionsLoaded && this.canSwitchTenants && this.currentUser) {
            this.loadAvailableTenants()
        }
    }

}
</script>

<style>

    .navbar .title {

        margin-left: 200px;

        font-size: 1rem;
        color: #007bff;
    }
    .navbar .brand-logo{

      color: #007bff;
      font-weight:700;
    }
    .navbar ul li a {
        color: #007bff;
    }

    .tenant-selector {
        margin-top: 16px;
    }

    .tenant-selector .v-input__control {
        min-height: 40px !important;
    }
</style>
